(function () {
  var data = window.HIRSCH_VEHICLES || {};

  document.querySelectorAll('[data-fitment]').forEach(function (root) {
    var form = root.querySelector('[data-fit-form]');
    var selMake = root.querySelector('[data-fit-make]');
    var selModel = root.querySelector('[data-fit-model]');
    var selVariant = root.querySelector('[data-fit-variant]');
    var outMake = root.querySelector('[data-fit-out="make"]');
    var outModel = root.querySelector('[data-fit-out="model"]');

    function fill(sel, placeholder, values) {
      sel.innerHTML = '';
      var o = document.createElement('option');
      o.value = ''; o.textContent = placeholder;
      sel.appendChild(o);
      values.forEach(function (v) {
        var opt = document.createElement('option');
        opt.value = v; opt.textContent = v;
        sel.appendChild(opt);
      });
      sel.disabled = values.length === 0;
    }

    function sync() {
      if (outMake) outMake.value = selMake.value;
      if (outModel) outModel.value = selModel.value;
    }

    var miss = root.querySelector('[data-fit-miss]');
    if (miss && root.querySelector('[data-fit-posted]')) {
      miss.open = true;
      miss.scrollIntoView({ block: 'center' });
    }

    fill(selMake, 'Hersteller wählen', Object.keys(data));
    selMake.disabled = false;

    selMake.addEventListener('change', function () {
      var models = data[selMake.value] ? Object.keys(data[selMake.value]) : [];
      fill(selModel, 'Modell wählen', models);
      fill(selVariant, 'Variante wählen', []);
      sync();
    });

    selModel.addEventListener('change', function () {
      var variants = (data[selMake.value] && data[selMake.value][selModel.value]) || [];
      fill(selVariant, 'Variante wählen', variants);
      sync();
    });

    // Leere Felder nicht in die URL übernehmen; bei Suche als Suchbegriff
    form.addEventListener('submit', function (e) {
      var isSearch = /\/search/.test(form.getAttribute('action') || '');
      if (!isSearch) {
        Array.prototype.forEach.call(form.elements, function (el) {
          if (el.name && el.tagName === 'SELECT' && !el.value) el.disabled = true;
        });
        return;
      }
      e.preventDefault();
      var q = [selMake.value, selModel.value, selVariant.value].filter(Boolean).join(' ');
      window.location.href = form.getAttribute('action') + '?type=product&q=' + encodeURIComponent(q);
    });
  });
})();
